import { css } from '@emotion/react';

const inputStyles = {
    label: css({
        position: 'relative',
    }),
    input: css({
        width: '100%',
        padding: '12px 10px 12px 40px',
        border: 'none',
        borderRadius: '8px',
        boxSizing: 'border-box',
        background: '#DAE7FA',
        fontStyle: 'normal',
        color: '#000000',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '20px',
        letterSpacing: 0,
        ':focus': {
            outline: 'none',
        },
        '::placeholder': {
            letterSpacing: 0,
            color: '#004FC680',
            fontWeight: 400,
            fontSize: '13px',
        },
    }),
    icon: css({
        paddingLeft: '12px',
        paddingRight: '12px',
        position: 'absolute',
        boxSizing: 'border-box',
        top: 2,
        bottom: 0,
        margin: 'auto 0',
    }),
    clearIcon: css({
        padding: '12px',
        position: 'absolute',
        boxSizing: 'border-box',
        top: 2,
        bottom: 0,
        right: 5,
        margin: 'auto 0',
    }),
};

export default inputStyles;
